export const ConsumoIa = () => {
  return (
    <div>ConsumoIa</div>
  )
}
